<section class="input-template-container">
  <section class="input-template-container">
    <div class="action-buttons-container">
      <ng-container *ngIf="model.status === inspectionStatus.toReview">
        <!-- Button Container -->
        <div class="save-complete-button-container" *cubeRole="[userRole.auditor]">
          <!-- Save  -->
          <button type="button" mat-raised-button color="primary" (click)="onClickSave()">
            <mat-icon>save</mat-icon>
            {{ "common.buttons.save" | translate }}
          </button>

          <!-- Complete  -->
          <button type="button" mat-raised-button color="primary" (click)="onClickComplete()"
            *ngIf="model.activeLevel === tunnelConstants.levels.l0">
            <mat-icon>assignment_turned_in</mat-icon>
            {{ "templates.complete" | translate }}
          </button>
        </div>

        <!-- Submit -->
        <div *cubeRole="[userRole.bmsInspectionManager]">
          <button type="button" mat-raised-button color="primary" (click)="onClickSubmit()">
            <mat-icon>assignment_turned_in</mat-icon>
            {{ "common.buttons.submit" | translate }}
          </button>
        </div>
      </ng-container>

      <!-- Back -->
      <div>
        <button type="button" mat-stroked-button color="primary" (click)="onClickBack()">
          <mat-icon>arrow_back</mat-icon> {{ "common.buttons.back" | translate }}
        </button>
      </div>
    </div>

    <!-- Formly Form -->
    <form [formGroup]="form">
      <formly-form [fields]="fields" [form]="form" [model]="model" [options]="options"></formly-form>
    </form>

    <!-- TEMP: Debug Component -->
    <app-debug-panel [form]="form.value" [levelNamesList]="levelsList" [model]="model" [options]="options"
      *ngIf="devMode.showDebugPanel"></app-debug-panel>
  </section>
</section>
